import { Box, Text } from "@chakra-ui/react";
import React from "react";
import type { CaregiverId } from "../../../../../shared/schema/schema";

type Props = {
  caregiverId: CaregiverId;
};

export default function CaregiverProfileComplianceAutomationsSection(props: Props) {
  const hostRef = React.useRef<HTMLDivElement | null>(null);
  const [isAngularUnavailable, setIsAngularUnavailable] = React.useState(false);

  React.useEffect(() => {
    const host = hostRef.current;
    const angular = (window as Window & { angular?: ng.IAngularStatic }).angular;
    const injector = angular?.element(document.body).injector();

    if (host === null || injector === undefined) {
      setIsAngularUnavailable(true);
      return undefined;
    }

    setIsAngularUnavailable(false);
    const scope = injector.get<ng.IRootScopeService>("$rootScope").$new(true) as ng.IScope & {
      caregiverId: CaregiverId;
    };
    const compile = injector.get<ng.ICompileService>("$compile");
    const element = document.createElement("compliance-automations-table");
    scope.caregiverId = props.caregiverId;
    element.setAttribute("caregiver-id", "caregiverId");

    host.replaceChildren(element);
    compile(element)(scope);
    scope.$applyAsync();

    return () => {
      scope.$destroy();
      host.replaceChildren();
    };
  }, [props.caregiverId]);

  return (
    <Box overflowX="auto">
      {isAngularUnavailable ? (
        <Text>Compliance Automations is available only inside the Angular shell.</Text>
      ) : null}
      <Box ref={hostRef} />
    </Box>
  );
}
